/**
 * Labstep
 *
 * @module components/FilterPost/Report/Options/Form
 * @desc Filter Metadata form
 */

import { FormReusableGroup } from 'labstep-web/core/Form/Reusable/Group';
import { PostFilter } from 'labstep-web/services/postFilter';
import type { PostFilterComparisonType } from 'labstep-web/services/postFilter/constants';
import { PostFilterComparison } from 'labstep-web/services/postFilter/constants';
import type React from 'react';
import { useCallback, useState } from 'react';
import { getOptionsFilterFields } from './fields';
import type { IFilterPostReportOptionsFormProps } from './types';

export const getPostFilterOptions = (
  field: string,
  comparison: PostFilterComparisonType,
  path?: string,
) => {
  return new PostFilter([[field, comparison]], path);
};

export const FilterPostReportOptionsForm: React.FC<
  IFilterPostReportOptionsFormProps
> = ({
  addPostFilter,
  onDone,
  path,
  field,
  defaultValues,
  entityName,
}) => {
  const [fields, setFields] = useState(
    getOptionsFilterFields(entityName),
  );

  const onSubmit = useCallback(
    (values): void => {
      const { value } = values.option;
      addPostFilter(
        getPostFilterOptions(
          field,
          PostFilterComparison.eq,
          path,
        ).getNode([value]),
        true,
      );
      onDone();
    },
    [path, addPostFilter],
  );

  return (
    <FormReusableGroup
      fields={fields}
      onSubmit={onSubmit}
      onDone={onDone}
      addAnother={false}
    />
  );
};
